import * as requests from './requests'
import constants from './constants'
import urls from './urls'

// Distribuidor

export async function getDistribuidores() {
  return requests
    .get(constants.API_URL_COMERCIANTES, urls.GET_DISTRIBUIDORES)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getDistribuidores2() {
  return requests
    .get(constants.API_URL_COMERCIANTES, urls.GET_DISTRIBUIDORES)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}
